var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.school.type !== 'class' && !_vm.school.hidden)?_c('div',{class:['SchoolHQSelector__SchoolHQSelectItem', 'min-h-32px py-6px px-16px hover:bg-white whitespace-normal'],on:{"click":function($event){return _vm.onSelect(_vm.school)}}},[_c('div',{class:[
        {
          'pl-24px': _vm.level === 1,
          'pl-48px': _vm.level === 2,
          'pl-72px': _vm.level === 3,
        },
        'leading-5 relative',
      ]},[(_vm.level > 0)?_c('div',{class:[
          {
            'left-[-6px]': _vm.level === 1,
            'left-[18px]': _vm.level === 2,
            'left-[42px]': _vm.level === 3,
          },
          'absolute top-0px flex items-center w-24px h-24px justify-center',
        ]},[_c('span',{staticClass:"w-6px h-6px rounded-3 bg-regular-grey block"})]):_vm._e(),_vm._v("\n      "+_vm._s(_vm.school.name)+"\n    ")])]):_vm._e(),_vm._v(" "),(_vm.hasChildren)?_vm._l((_vm.school.children),function(item){return _c('SchoolHQSelectItem',{key:item.id,attrs:{"school":item,"searchText":_vm.searchText,"parentSchool":_vm.school,"onSelect":_vm.onSelect,"level":_vm.level + 1}})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }